import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export type GodModeIdleDialogResult = 'stay' | 'leave' | 'timeout';

@Component({
  selector: 'app-god-mode-idle-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule],
  templateUrl: './god-mode-idle-dialog.component.html',
  styleUrls: ['./god-mode-idle-dialog.component.scss'],
})
export class GodModeIdleDialogComponent implements OnDestroy {
  secondsRemaining: number;
  private readonly countdownId: ReturnType<typeof setInterval>;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: { seconds: number },
    private readonly dialogRef: MatDialogRef<GodModeIdleDialogComponent, GodModeIdleDialogResult>,
  ) {
    this.secondsRemaining = data.seconds;
    this.countdownId = setInterval(() => {
      this.secondsRemaining -= 1;
      if (this.secondsRemaining <= 0) {
        this.dialogRef.close('timeout');
      }
    }, 1000);
  }

  stay(): void {
    this.dialogRef.close('stay');
  }

  leave(): void {
    this.dialogRef.close('leave');
  }

  ngOnDestroy(): void {
    clearInterval(this.countdownId);
  }
}
